module.exports = __webpack_public_path__ + "img/baseline-search-24px.3b7a5ef9.svg";